module.exports = __webpack_public_path__ + "lp/img/movie_box_sp_blk@2x.e127a5e1.png";